<template>
  <div class="container containerEtiqueta orderGenerationContainer">
    <div class="mask" v-if="showMask" @click="hideAllModals"></div>

    <div class="back-button-wrapper no-print">
      <a
        href="/painel/meus-envios#liberados"
        title="Meus envios"
        class="btnBack"
      >
        <svg class="ico">
          <use xlink:href="/images/svg-symbols.svg#arrow-back" />
        </svg>

        <span>Meus Envios</span>
      </a>
    </div>

    <div class="no-print">
      <transition name="fade">
        <div v-if="showLoader" class="progress">
          <transition name="fade">
            <div v-if="progressVisible" class="progress-bar">
              <div class="progress-bar-content" :style="{ width: progress }"></div>
            </div>
          </transition>

          <transition name="fade">
            <loader-pulse v-if="!progressVisible"></loader-pulse>
          </transition>
        </div>
      </transition>
    </div>

    <div class="no-print">
      <h2 class="ttl">Etiquetas</h2>
      <div v-if="isSafari" class="alert -yellow">
        <svg class="ico">
          <use xlink:href="/images/svg-symbols.svg#ico-alert-yellow"></use>
        </svg>
        <p>Usuário Safari: Antes de confirmar a impressão, desabilite a opção "Imprimir cabeçalhos e rodapés" na janela de impressão.</p>
      </div>
    </div>

    <div class="no-print buttons">
      <div class="buttons__wrapper">
        <button
          class="btnConfirm"
          @click="handlePrint"
        >
          Imprimir
        </button>

        <button
          v-if="isShareble"
          class="btnShare"
          @click="shareConfirm"
        >
          Compartilhar
        </button>
      </div>

      <div class="form">
        <div class="formLineBox">
          <fieldset class="checkLine">
            <div class="inputBox">
              <input
                type="checkbox"
                name="chckCP"
                id="chckCP"
                class="customCheckBullet"
                v-model="changeMode"
              >
              <label
                for="chckCP"
                title="No modo de impressão tamanho cartão postal pode ser impresso somente as etiquetas."
              >Tamanho cartão postal (etiquetas)</label>
            </div>
          </fieldset>
        </div>

        <div class="formLineBox">
          <fieldset class="checkLine">
            <div class="inputBox">
              <input
                type="checkbox"
                name="chckNoTags"
                id="chckNoTags"
                class="customCheckBullet"
                v-model="printTags"
              >
              <label for="chckNoTags">Imprimir etiquetas</label>
            </div>
          </fieldset>
        </div>

        <div v-if="orders_where_jadlog.length || orders_where_buslog.length" class="formLineBox">
          <fieldset class="checkLine">
            <div class="inputBox">
              <input
                type="checkbox"
                name="chckNoReceipt"
                id="chckNoReceipt"
                class="customCheckBullet"
                v-model="printReceipt"
              >

              <label for="chckNoReceipt">Imprimir comprovante de postagem</label>

              <me-tooltip
                message="
                  <p class='jadlogReceiptTooltip'>
                    Comprovantes exclusivos para serviços Jadlog.

                    <a
                      href='https://ajuda.melhorenvio.com.br/pt-BR/articles/4382025-comprovante-de-postagem-para-envios-via-jadlog'
                      target='_blank'
                      rel='noreferrer noopener'
                    >
                      Saiba mais.
                    </a>
                  </p>
                "
                :max-width="256"
              >
                <svg class="ico"><use xlink:href="/images/svg-symbols.svg#info"></use></svg>
              </me-tooltip>
            </div>
          </fieldset>
        </div>

        <div
          v-if="canPrintPLPCorreios"
          class="formLineBox"
        >
          <fieldset class="checkLine">
            <div class="inputBox">
              <input
                type="checkbox"
                name="chckNoPLP"
                id="chckNoPLP"
                class="customCheckBullet"
                v-model="printCorreiosPLP"
              >
              <label for="chckNoPLP">Imprimir PLP dos Correios</label>
              <me-tooltip
                message="
                  <div class='correiosPlpTooltip'>
                    Consulte sua agência de postagem sobre a necessidade de imprimir a PLP.
                    <a
                      target='_blank'
                      href='https://ajuda.melhorenvio.com.br/pt-BR/articles/5013150-o-que-e-uma-plp-e-para-que-ela-serve'
                    >
                        Saiba mais.
                    </a>
                  </div>
                "
                :max-width="200"
              >
                <svg class="ico"><use xlink:href="/images/svg-symbols.svg#info"></use></svg>
              </me-tooltip>
            </div>
          </fieldset>
        </div>

        <div v-if="orders_with_declarations.length" class="formLineBox">
          <fieldset class="checkLine">
            <div class="inputBox">
              <input
                type="checkbox"
                name="chckNoDeclaration"
                id="chckNoDeclaration"
                class="customCheckBullet"
                v-model="printDeclarations"
              >
              <label for="chckNoDeclaration">Imprimir declarações</label>
            </div>
          </fieldset>
        </div>
      </div>

      <a v-if="banner && banner.printscreen" :href="banner.link" target="_blank" class="melhor-drop">
        <figure class="melhor-drop__figure">
          <img
            class="melhor-drop__figure--slim"
            :src="banner.picture_desktop"
            :title="banner.title"
            style="margin-bottom: -20px;"
          >
        </figure>
      </a>
    </div>

    <alertbox-mixed-postage-types
      v-if="hasMixedPostageTypes"
      class="mb-6 no-print"
      @handle-action="$refs['modal-mixed-postage-types'].open()"
    />

    <order-generation-information
      v-if="allOrders.length"
      :allOrders="allOrders"
      :generatedOrders="generatedOrders"
      @on-illustration-load="onIllustrationLoad"
      @generating="onGenerating"
      @generated="onGenerated"
      @toggleTagDialog="toggleTagDialog"
    />

    <div
      v-show="illustrationLoaded"
      class="print-box"
      :class="{
        dialog: showTagDialog,
      }"
    >
      <button class="closeDialog" @click="toggleTagDialog">
        <svg class="ico"><use xlink:href="/images/svg-symbols.svg#close"></use></svg>
      </button>

      <div v-show="showTags">
        <div
          ref="tags"
          class="tags-list"
          :class="{
            'tags-list--postal': changeMode
          }"
        >
          <template v-for="(tag, tagIndex) in lazyOrders">
            <template v-for="(volume, volumeIndex) in tag.volumes">
              <div
                :key="tag.id + '-' + volumeIndex"
                class="tags-list__item"
              >
                <div v-if="getTPrinterTag(tag, volumeIndex)">
                  <div :class="printerPostal">
                    <img
                      :src="volume.tagImageLink"
                      :alt="tag.service.name"
                      :class="tag.reminder ? 'tagReminder' : 'tagPrinter'"
                      class="t-print-tag"
                      @load="onImageLoad"
                      @error="onImageLoad"
                    />
                  </div>
                </div>

                <shipment-tag
                  v-else
                  :id="tag.id"
                  :generateTag="tag"
                  :generateVolume="volume"
                  :volume-index="volumeIndex"
                  :is-melhor-ponto-qr-code-tester="isMelhorPontoQrCodeTester"
                />
              </div>

              <jadlog-instrucoes
                v-if="!tagIndex && !volumeIndex && showReceipt && orders_where_jadlog.length"
                class="tags-list__item"
              />
            </template>
          </template>
        </div>
        <div class="no-print"><hr></div>
      </div>

      <template v-for="orderCorreios in orders_where_correios">
        <div
          :key="`ars-${orderCorreios.id}`"
          v-if="Object.keys(orderCorreios.correios.ars).length"
          class="correios-ars page-break-inside-avoid"
        >
          <div class="page-break"></div>
          <div class="no-print">
            <h4 class="subTtl">AR's</h4>
            <div class="txtAr">
              <p class="text-center">Dê preferência ao AR disponibilizado pela agência, pois o papel é mais resistente que o da folha de ofício.</p>
              <p class="text-center">A maioria das agências disponibiliza AR para uso dos clientes, basta preencher com os mesmos dados que esse AR e colar na sua caixa.</p>
            </div>
            <div class="buttons">
              <button class="btnPlp" @click="printCorreiosAR = !printCorreiosAR">
                <template v-if="printCorreiosAR">Não quero imprimir AR dos Correios</template>
                <template v-else>Quero imprimir AR dos Correios</template>
              </button>
            </div>
          </div>
          <div class="clearfix" v-show="printCorreiosAR">
            <template>
              <correios-ar
                :key="orderCorreios.correios.ars.id"
                :contract="orderCorreios.correios.ars.contract"
                :tracking="orderCorreios.correios.ars.tracking"
                :code="orderCorreios.correios.ars.code"
                :from-name="orderCorreios.correios.ars.from_name"
                :from-address="orderCorreios.correios.ars.from_address"
                :from-location-number="orderCorreios.correios.ars.from_number"
                :from-complement="orderCorreios.correios.ars.from_complement"
                :from-district="orderCorreios.correios.ars.from_district"
                :from-city="orderCorreios.correios.ars.from_city"
                :from-state-abbr="orderCorreios.correios.ars.from_state_abbr"
                :from-country-id="orderCorreios.correios.ars.from_country_id"
                :from-postal-code="orderCorreios.correios.ars.from_postal_code"
                :to-name="orderCorreios.correios.ars.to_name"
                :to-address="orderCorreios.correios.ars.to_address"
                :to-location-number="orderCorreios.correios.ars.to_number"
                :to-complement="orderCorreios.correios.ars.to_complement"
                :to-district="orderCorreios.correios.ars.to_district"
                :to-city="orderCorreios.correios.ars.to_city"
                :to-state-abbr="orderCorreios.correios.ars.to_state_abbr"
                :to-country-id="orderCorreios.correios.ars.to_country_id"
                :to-postal-code="orderCorreios.correios.ars.to_postal_code"
              />
            </template>
          </div>
          <div class="no-print"><hr></div>
        </div>
      </template>

      <div
        v-if="printCorreiosPLP"
        :class="{
          'page-break-before-page': printTags
        }"
      >
        <template v-for="plp in correiosPLP">
          <div
            v-if="plp.authorization_code"
            :key="plp.authorization_code"
            class="correios-plps page-break-inside-avoid"
          >
            <div class="no-print">
              <h4 class="subTtl">PLP's</h4>
            </div>
            <div class="clearfix">
              <correios-plp
                :contract="plp.contract"
                :authorization-code="String(plp.authorization_code || '')"
                :service-codes="plp.service_code"
                :service-names="content.correios.services"
              />
            </div>
            <div class="no-print"><hr></div>
          </div>
        </template>
      </div>

      <div
        v-if="orders_where_latam_cargo.length || orders_where_azul_cargo.length && !changeMode"
        :class="{
          'latamcargo-minutas' : orders_where_latam_cargo.length,
          'azulcargo-minutas' : orders_where_azul_cargo.length
        }"
      >
        <div v-if="orders_where_latam_cargo.length" class="page-break">
          <div class="buttons no-print">
            <button class="btnPlp" @click="printLatamCargoMinuta = !printLatamCargoMinuta">
              <template v-if="printLatamCargoMinuta">Não quero imprimir Minutas da LATAM Cargo</template>
              <template v-else>Quero imprimir Minutas da LATAM Cargo</template>
            </button>
          </div>

          <div class="clearfix" v-show="printLatamCargoMinuta">
            <latam-minuta v-for="order in orders_where_latam_cargo" :key="order.id" :order="order" />
          </div>

          <div class="no-print"><hr></div>
        </div>

        <div v-if="orders_where_azul_cargo.length">
          <div class="no-print">
            <h4 class="subTtl">Minutas</h4>
            <div class="txtAr">
              <p style="text-align: center;">
                Você deve levar a sua caixa até a unidade da Azul Cargo Express com a etiqueta do Melhor Envio,
                as minutas impressas e o documento da carga (DANFE ou declaração de conteúdo preenchida)
              </p>
            </div>
          </div>

          <div class="buttons no-print">
            <button class="btnPlp" @click="printAzulCargoMinuta = !printAzulCargoMinuta">
              <template v-if="printAzulCargoMinuta">Não quero imprimir Minutas da Azul Cargo Express</template>
              <template v-else>Quero imprimir Minutas da Azul Cargo Express</template>
            </button>
          </div>

          <div class="clearfix" v-show="printAzulCargoMinuta">
            <azul-cargo-minuta v-for="order in orders_where_azul_cargo" :key="order.id" :order="order" />
          </div>

          <div class="no-print"><hr></div>
        </div>
      </div>

      <div v-if="orders_with_declarations.length && !changeMode && printDeclarations">
        <div class="no-print">
          <h4 class="subTtl">Declarações de conteúdo</h4>
        </div>

        <div
          class="page-break-inside-avoid"
          v-for="order in orders_with_declarations" :key="order.id"
        >
          <orders-declarations :order="order" />
        </div>

        <div class="no-print"><hr></div>
      </div>

      <div v-if="showReceipt">
        <component
          v-for="idAgency in getAgencyReceipt"
          :key="idAgency"
          :is="getReceiptComponent(idAgency)"
        />
      </div>
    </div>

    <transition name="fade">
      <div class="modal modal--small modal--share modal--center" v-if="modalShareConfirmed">
        <div class="modal__header">
          <p>Compartilhar etiquetas</p>

          <button class="closeModal" aria-label="Fechar modal">
            <svg class="ico" @click="hideModal('modalShareConfirmed')">
              <use xlink:href="/images/svg-symbols.svg#close"></use>
            </svg>
          </button>
        </div>
        <div class="modal__content form">
          <p>Habilitando o compartilhamento da sua etiqueta ela se tornará pública. Isso significa que nós vamos gerar um link permitindo o acesso de outras pessoas à janela de impressão dessa etiqueta.</p>

          <div class="formLineBox">
            <fieldset class="checkLine">
              <div class="inputBox">
                <input
                  type="checkbox"
                  name="chckMode"
                  id="chckMode"
                  class="customCheckBullet"
                  v-model="linkPublic"
                >
                <label for="chckMode">Link Público</label>
              </div>
            </fieldset>
          </div>
          <transition name="fade">
            <div class="copyBox" v-if="linkPublic && link">
              <div class="inputBox">
                <input type="text" :value="linkWithQuery" disabled>
                <button type="button" v-clipboard:copy="linkWithQuery">
                  <svg class="ico">
                    <use xlink:href="/images/svg-symbols.svg#copy"></use>
                  </svg>
                </button>
              </div>
            </div>
          </transition>
        </div>
        <div class="modal__footer">
          <button type="button" class="btnBorder btnBorder--small" @click="showShareEmail" aria-label="Enviar por email">
            <span>Enviar por email</span>
          </button>
        </div>
      </div>
    </transition>

    <transition name="fade">
      <div class="modal modal--small modal--center" v-if="modalShareEmail">
        <div class="modal__header">
          <p>Compartilhar etiquetas</p>

          <button class="closeModal" aria-label="Fechar modal">
            <svg class="ico" @click="hideModal('modalShareEmail')">
              <use xlink:href="/images/svg-symbols.svg#close"></use>
            </svg>
          </button>
        </div>
        <div class="modal__content">
          <p>Informe o email de quem receberá essa etiqueta:</p>

          <div class="form">
            <form action="javascript:;" class="form form-space">
              <div class="formBox">
                <div class="formLineBox">
                  <fieldset
                    class="formLine"
                    :class="{ active: email, error: $v.email.$error, focus: focus.email }"
                  >
                    <div class="inputBox">
                      <label for="email">Email *</label>
                      <input
                        name="email"
                        id="email"
                        autofocus
                        v-model="email"
                        maxlength="255"
                        @focus="iptFocus('email', $event)"
                        @blur="iptBlur('email', $event)"
                        @input="$v.email.$touch"
                      >
                      <p class="errorText">{{ errors.email }}</p>
                    </div>
                  </fieldset>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="modal__footer">
          <button type="button" class="btnBorder btnBorder--small" @click="shareEmail" aria-label="Enviar compartilhamento de etiquetas">
            <span>Enviar</span>
          </button>
        </div>
      </div>
    </transition>

    <modal-mixed-postage-types
      v-if="hasMixedPostageTypes"
      ref="modal-mixed-postage-types"
      class="no-print"
      :orders="generatedOrders"
      @update-preferences="shouldShowMixedPostageTypesModal = false"
      @handle-confirm="print"
    />
  </div>
</template>

<script>
  import { required, email } from 'vuelidate/lib/validators';
  import ShipmentTag from 'commons/js/components/print/ShipmentTag.vue';
  import CorreiosAR from 'commons/js/components/print/CorreiosAR.vue';
  import CorreiosPLP from 'commons/js/components/print/CorreiosPLP.vue';
  import OrdersDeclarations from './OrdersDeclarations.vue'
  import JadlogInstrucoes from 'commons/js/components/print/JadlogInstrucoes.vue';
  import JadlogComprovante from 'commons/js/components/print/JadlogComprovante.vue';
  import BuslogComprovante from 'commons/js/components/print/BuslogComprovante.vue';
  import LatamCargoMinuta from 'commons/js/components/print/LatamCargoMinuta.vue';
  import AzulCargoMinuta from 'commons/js/components/print/AzulCargoMinuta.vue';
  import Features from 'commons/js/Features';
  import ShippingDefinitions from 'commons/js/ShippingDefinitions';
  import OrderGenerationInformation from './printer/OrderGenerationInformation.vue';
  import AsyncOrderGeneration from './printer/AsyncOrderGeneration';
  import Tooltip from 'commons/js/components/atoms/Tooltip';
  import LoaderPulse from 'commons/js/components/atoms/LoaderPulse';
  import { getPrintPreference } from 'commons/js/utils/print';
  import { PRINT_QUALITIES } from 'commons/js/config/print';
  import { printWebview } from 'commons/js/utils/webview';

  import AlertboxMixedPostageTypes from "commons/js/components/alerts/AlertboxMixedPostageTypes.vue";
  import ModalMixedPostageTypes from "commons/js/components/modals/ModalMixedPostageTypes.vue"

  const LAZY_LOAD_PER_PAGE = 20;
  const LAZY_LOAD_DELAY = 100;
  const MIN_TAGS_FOR_IMG_LOADER = 15;

  export default {
    mixins: [
      Features,
      ShippingDefinitions,
      AsyncOrderGeneration,
    ],

    components: {
      'shipment-tag': ShipmentTag,
      'correios-ar': CorreiosAR,
      'correios-plp': CorreiosPLP,
      'orders-declarations': OrdersDeclarations,
      'jadlog-instrucoes': JadlogInstrucoes,
      'jadlog-comprovante': JadlogComprovante,
      'buslog-comprovante': BuslogComprovante,
      'latam-minuta': LatamCargoMinuta,
      'azul-cargo-minuta': AzulCargoMinuta,
      'order-generation-information': OrderGenerationInformation,
      'me-tooltip': Tooltip,
      'loader-pulse': LoaderPulse,
      AlertboxMixedPostageTypes,
      ModalMixedPostageTypes
    },

    props: {
      printerKey: {
        required: false,
      },
      share: {
        required: false,
      },
      content: {
        required: false,
      }
    },

    data() {
      return {
        loading: true,

        generating: false,
        generated: false,

        showMask: false,
        modalShareConfirmed: false,
        modalShareEmail: false,

        email: '',

        printerPostal: '',

        errorMessages: {
          required: 'Campo obrigatório! Não deixe em branco.',
          minLength: 'Dado inválido! Verifique se o mesmo está correto.',
          maxLength: 'Dado inválido! Verifique se o mesmo está correto.',
          sameAsPassword: 'Senha inválida! Verifique se o mesma está correta.',
          password: 'Senha fraca! Combine letras e números.'
        },

        errors: {
          email: ''
        },

        focus: {
          email: false
        },

        printTags: true,
        printCorreiosPLP: false,
        printCorreiosAR: true,
        printLatamCargoMinuta: true,
        printAzulCargoMinuta: true,
        printDeclarations: true,
        printReceipt: true,
        changeMode: false,
        isShareble: false,
        link: '',
        linkPublic: false,

        isSafari: false,

        banner: MEConfig.get('banner'),

        showTagDialog: false,
        generateKey: '',
        illustrationLoaded: false,

        page: 0,

        loadedImages: 0,

        shouldShowMixedPostageTypesModal: !MEConfig.get('preferences.mixed_postage_types_alert'),
        printPreference: getPrintPreference(),
      };
    },

    computed: {
      generatedOrders() {
        if (!this.allOrders.length) {
          return [];
        }

        return this.allOrders
          .filter(order => {
            if (order.generated_at) {
              if (!order.generated_key) {
                return true;
              }

              if (order.generated_key && !order.generated_key.failed_at) {
                return true;
              }
            }

            return false;
          })
          .sort((a, b) => Number(this.isJadlog(b.service.company.id)) - Number(this.isJadlog(a.service.company.id)))
      },

      failedOrders() {
        if (!this.allOrders.length) {
          return [];
        }

        return this.allOrders.filter(order => order.generated_key && order.generated_key.failed_at);
      },

      tPrinterOrders() {
        return this.generatedOrders.reduce(
          (acc, value) => (
            acc + value.volumes.filter((volume) => (
              this.isTPrinterOrder(volume)
            )).length
          ),
          0
        );
      },

      allImagesLoaded() {
        return this.allOrders.length <= MIN_TAGS_FOR_IMG_LOADER || this.loadedImages >= this.tPrinterOrders;
      },

      showLoader() {
        if (this.generating || this.failedOrders.length) return false;

        return this.loading || !this.allImagesLoaded;
      },

      showTags() {
        return this.printTags && (this.generatedOrders.length || this.lazyOrders.length);
      },

      orders_with_declarations() {
        return Object.freeze(this.generatedOrders.filter(order => {
          const id = order.service.company.id;

          if (this.isCorreios(id) || this.isJadlog(id) || this.isBuslog(id) || this.isLoggi(id) || this.isJET(id)) {
            return !(order.invoice && (order.invoice.number || order.invoice.key));
          }

          if (this.isAzulCargoExpress(id) || this.isLATAMCargo(id)) {
            return !order.invoice || !order.invoice.key;
          }

          return false;
        }));
      },

      orders_where_latam_cargo() {
        return this.generatedOrders.filter(order => {
          return this.isLATAMCargo(order.service.company.id);
        });
      },

      orders_where_azul_cargo() {
        return this.generatedOrders.filter(order => {
          return this.isAzulCargoExpress(order.service.company.id);
        });
      },

      orders_where_correios() {
        return this.generatedOrders.filter(order => {
          if (!order.correios) {
            return false;
          }
          return this.isCorreios(order.service.company.id);
        });
      },

      orders_where_jadlog() {
        return this.generatedOrders.filter(order => {
          return this.isJadlog(order.service.company.id);
        });
      },

      orders_where_buslog() {
        return this.generatedOrders.filter(order => {
          return this.isBuslog(order.service.company.id);
        });
      },

      getAgencyReceipt() {
        const agency = this.generatedOrders.map(order => {
          return order.service.company.id;
        });

        const idBuslog = ShippingDefinitions.BUSLOG_ID;
        const idJadlog = ShippingDefinitions.JADLOG_ID;

        const getReceipt = agency.filter((value, index, self) => {
          return (value === idBuslog || value === idJadlog) && self.indexOf(value) === index;
        });

        return getReceipt;
      },

      correiosPLP() {
        return this.generatedOrders.reduce((plps, order) => {
          const correios = order.correios;

          if (correios) {
            const plp = correios.plps[Object.keys(correios.plps)[0]];

            if (plp.authorization_code in plps) {
              plps[plp.authorization_code] = {
                ...plps[plp.authorization_code],
                service_code: plps[plp.authorization_code].service_code + `,${plp.service_code}`,
              };

              return plps;
            }

            plps = {
              ...plps,
              ...order.correios.plps,
            }
          }
          return plps;
        }, {});
      },

      showReceipt() {
        return (this.orders_where_jadlog.length || this.orders_where_buslog.length) && this.printReceipt;
      },

      canPrintPLPCorreios() {
       const validationPLP = {
         hasAuthotizationCode: this.orders_where_correios.some(order => order.authorization_code),
         hasCorreiosPLP: this.orders_where_correios.some(order => Object.keys(order.correios.plps).length)
       }

       if (!this.orders_where_correios.length || !validationPLP.hasAuthotizationCode) {
          this.printCorreiosPLP = false;
          return false;
        }

        return validationPLP.hasCorreiosPLP
      },

      linkWithQuery(){
        return `${this.link}?public=true`
      },

      totalOrders() {
        return this.generatedOrders.length + this.failedOrders.length
      },

      lazyOrders() {
        if (this.generating) {
          return Object.freeze(this.generatedOrders);
        }

        return Object.freeze(this.generatedOrders.slice(0, LAZY_LOAD_PER_PAGE * this.page));
      },

      lazyOrdersFullyLoaded() {
        return this.lazyOrders.length >= this.allOrders.length - this.failedOrders;
      },

      progress() {
        if (this.generating || !this.generatedOrders.length) return '0%';

        const percentage = ((this.lazyOrders.length + this.loadedImages) / (this.generatedOrders.length + this.tPrinterOrders)) * 100;

        return `${percentage}%`;
      },

      progressVisible() {
        if (this.generating) return false;

        return this.illustrationLoaded && !!this.generatedOrders.length;
      },

      isMelhorPontoQrCodeTester() {
        return MEFeatureFlag.enabled('PP-CORREIOS-JADLOG-TAG');
      },

      hasMixedPostageTypes() {
        if (!this.generatedOrders.length || this.generatedOrders.length === 1) {
          return false;
        }

        const hasIndustrialOrders = this.generatedOrders.some(ord => this.isIndustrialService(ord.service_id));

        const hasRetailOrders = this.generatedOrders.some(ord => !this.isIndustrialService(ord.service_id));

        return hasIndustrialOrders && hasRetailOrders;
      }
    },

    watch: {
      showLoader: {
        immediate: true,
        handler(value) {
          if (value) {
            document.body.classList.add('no-scroll-y');
            return;
          }

          document.body.classList.remove('no-scroll-y');
        },
      },

      changeMode(value) {
        const file = window.files[Number(value)];
        if (file) {
          if (value) {
            this.printDeclarations = false,
            this.printReceipt = false,
            this.printCorreiosPLP = false;
          }
          $('[media=print]').prop('href', file);
        }
      },

      async linkPublic(value) {
        if (!this.isShareble) {
          return;
        }

        try {
          const result = await axios.post('/api/v2/me/shipment/print', {
            mode: value ? 'public' : 'private',
            orders: this.generatedOrders.map(e => e.id),
            cache: false
          });

          this.link = result.data.url;
        } catch (e) {
          console.error(e)
        }
      },

      printTags() {
        this.saveOptions();
      },

      printCorreiosPLP(value) {
        if (value) this.changeMode = false;
        this.saveOptions();
      },

      printReceipt(value) {
        if (value) this.changeMode = false;
      },

      printDeclarations(value) {
        if (value) this.changeMode = false;
        this.saveOptions();
      },

      printCorreiosAR(value) {
        this.saveOptions();
        if (value) this.changeMode = false;
      },

      printLatamCargoMinuta(value) {
        this.saveOptions();
        if (value) this.changeMode = false;
      },

      printAzulCargoMinuta(value) {
        this.saveOptions();
        if (value) this.changeMode = false;
      },

      illustrationLoaded(value) {
        if (value && (this.allOrders.length === this.totalOrders)) {
          this.loadTags();
        }
      },
    },

    created() {
      this.isShareble = this.share === 'true';

      this.loadOptions();

      let not_paid = [], expired = [];

      if (this.generatedOrders && this.generatedOrders.length) {
        for (let i = 0, length = this.generatedOrders.length; i < length; i++) {
          let tag = this.generatedOrders[i];
          if (tag.canceled_at) {
            not_paid.push(tag.protocol);
          } else if (tag.expired_at) {
            expired.push(tag.protocol);
          }
        }
      }

      this.isSafari =
        /constructor/i.test(window.HTMLElement) ||
        (function(p) {
          return p.toString() === '[object SafariRemoteNotification]';
        })(
          !window['safari'] ||
            (typeof safari !== 'undefined' && safari.pushNotification)
        );
    },

    methods: {
      loadTags() {
        const element = this.$refs.tags;
        const observer = new MutationObserver(() => {
          if (this.lazyOrdersFullyLoaded) {
            observer.disconnect();

            this.loading = false;
          }

          setTimeout(() => {
            this.page++;
          }, LAZY_LOAD_DELAY);
        });
        const config = {
          attributes: false,
          childList: true,
          characterData: false,
        };
        observer.observe(element, config);

        this.page++;
      },

      onImageLoad() {
        this.loadedImages++;
      },

      onGenerating() {
        this.generating = true;
        this.loading = false;
      },

      onGenerated() {
        this.generated = true;

        if (this.loading && this.lazyOrdersFullyLoaded) this.loading = false;
      },

      isTPrinterOrder(volume) {
        return this.printPreference === PRINT_QUALITIES.DEFAULT && volume.tagImageLink;
      },

      getTPrinterTag(tag, volume) {
        if (this.printPreference !== PRINT_QUALITIES.DEFAULT) return false;

        const tPrinter = tag.t_printer;
        const image = tag.volumes[volume].tagImageLink;

        if (tPrinter && image && !tPrinter.failed_at) {
          if (this.changeMode) this.printerPostal = 't-printer-postal';

          return true;
        }

        return false;
      },

      generatedOrder() {
        if (this.generatedOrders && this.generatedOrders.length) {
          this.generatedOrders.forEach(tag => {
            if (tag.canceled_at) {
              not_paid.push(tag.protocol);
            } else if (tag.expired_at) {
              expired.push(tag.protocol);
            }
          })
        }
      },

      loadOptions() {
        if (this.isShareble) {
          axios.get('/api/v2/me/settings/printer-options').then(response => {
            if (response.data) {
              this.printTags = response.data.print_tags;
              this.printCorreiosPLP = response.data.print_correios_plp;
              this.printCorreiosAR = response.data.print_correios_ar;
              this.printLatamCargoMinuta = response.data.print_minutas;
              this.printAzulCargoMinuta = response.data.print_minutas;
              this.printDeclarations = response.data.print_declarations;
            }
          });
        }
      },

      saveOptions() {
        if (this.isShareble) {
          axios.put('/api/v2/me/settings/printer-options', {
            print_tags: this.printTags,
            print_correios_plp: this.printCorreiosPLP,
            print_correios_ar: this.printCorreiosAR,
            print_minutas: this.printLatamCargoMinuta && this.printAzulCargoMinuta,
            print_declarations: this.printDeclarations
          });
        }
      },

      handlePrint() {
        if (this.hasMixedPostageTypes && this.shouldShowMixedPostageTypesModal) {
          this.$refs['modal-mixed-postage-types'].open({customAction: true});

          return;
        }

        this.print();
      },

      print() {
        let tmp = document.title;
        const jobName = 'MELHOR ENVIO - ' + this.printerKey;
        document.title = jobName;
        window.print();
        document.title = tmp;

        printWebview(jobName);
      },

      shareConfirm() {
        if (!this.isShareble) {
          return;
        }
        this.linkPublic = true;
        this.hideAllModals();
        this.showModal('modalShareConfirmed');
      },

      showShareEmail() {
        if (!this.isShareble) {
          return;
        }
        this.hideAllModals();
        this.showModal('modalShareEmail');
      },

      shareEmail() {
        if (!this.isShareble) {
          return;
        }
        if (this.$v.$invalid) {
          this.$v.$touch();
          let errorTypes = Object.keys(this.errorMessages);
          Object.keys(this.$v.$params).forEach(e => {
            for (let i = 0; i < errorTypes.length; i++) {
              let errorType = errorTypes[i];
              if (
                this.$v[e].hasOwnProperty(errorType) &&
                !this.$v[e][errorType]
              ) {
                this.errors[e] = '';
                if (this.errorMessages.hasOwnProperty(errorType)) {
                  this.errors[e] = this.errorMessages[errorType];
                }
                break;
              }
            }
          });
          return;
        }
        axios.post('/api/v2/me/shipment/share', {
          email: this.email,
          orders: this.generatedOrders.map(e => e.id)
        });
        this.hideAllModals();
      },

      showModal(modal) {
        this[modal] = true;
        this.showMask = true;
      },

      hideModal(modal) {
        this[modal] = false;
        this.showMask = false;
      },

      hideAllModals() {
        this.showMask = false;
        this.modalShareConfirmed = false;
        this.modalShareEmail = false;
      },

      iptFocus(ipt) {
        this.focus[ipt] = true;
      },

      iptBlur(ipt) {
        this.focus[ipt] = false;
        this.updateErrorMessage(ipt);
      },

      updateErrorMessage(key) {
        if (this.$v[key] && this.errorMessages) {
          for (const [errorType, message] of Object.entries(this.errorMessages)) {
            if (!this.$v[key][errorType]) {
                this.errors[key] = String(message);
                return;
            }
          }
        }

        this.errors[key] = '';
      },

      toggleTagDialog() {
        if (!this.generatedOrders.length) {
          return;
        }
        this.showTagDialog = !this.showTagDialog;
        this.showMask = !this.showMask;
        this.$scrollTo('.closeDialog');
      },

      async loadOrdersInitialState() {
        this.allOrders = await this.getOrdersByPrintKey();

        await this.setGenerateKey();
      },

      getReceiptComponent(id) {
        switch (id) {
          case ShippingDefinitions.JADLOG_ID:
              return 'jadlog-comprovante';
          case ShippingDefinitions.BUSLOG_ID:
              return 'buslog-comprovante';
          default:
              return '';
        }
      },

      async setGenerateKey() {
        const order = this.allOrders.find(({ generated_key }) => generated_key && generated_key.generate_key);

        this.generateKey = order && order.generated_key.generate_key;

        await this.$nextTick();
      },

      onIllustrationLoad() {
        this.illustrationLoaded = true;
      },
    },

    validations: {
      email: {
        required,
        email
      }
    },
  };
</script>

<style lang="stylus" scoped>
$brightGray = #3b3f51;
$curiousBlue = #3598dc

.back-button-wrapper
  position absolute
  top 58px
  left 28px

  @media screen and (min-width: 600px)
    top 36px
    left 56px

  @media screen and (min-width: 1024px)
    position fixed
    top 74px
    left 44px

.form-space
  max-width 400px
  margin 0 auto

.print-box
  padding 15px
  background white
  box-shadow 0 0 20px rgba(0, 0, 0, .5)
  margin-bottom 25px

.text-center
  text-align center

.tags-list
  display grid
  grid-template-columns repeat(2, 1fr)

  @media print
    display block
    font-size 0

  &__item
    @media print
      width 50%
      display inline-block
      vertical-align top
      break-inside avoid

    ^[-1]--postal &
      @media print
        width 100%

.t-print-tag
  width 385px
  max-width 100%
  display block

.tagReminder
  margin-top 1px
  height 543px

.tagPrinter
  margin 16px 0px 5px
  height 528px

.progress
  width 100%
  height 100%
  display flex
  align-items center
  justify-content center
  position fixed
  top 0
  left 0
  background-color rgba(#000, 0.5)

  &-bar
    width 300px
    height 25px
    max-width 80%
    background-color $brightGray
    border 10px solid $brightGray
    border-radius 50px
    overflow hidden

    &-content
      height 100%
      background-color $curiousBlue
      transition width .3s linear

.buttons
  &__wrapper
    display flex
    flex-wrap wrap
    justify-content center
    gap 1rem

    .btnConfirm
    .btnShare
      margin 0

@media (max-width: 600px)
  .print-box
    margin 10px

@media print
  html, body, .container, .row, .print-box, [class^=col]
    padding 0 !important
    margin 0 !important

  .print-box
    box-shadow none

  .no-print
    display none
</style>
